import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TranslatedText, { path: "action.view.links.default" }),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("a", {
      href: _ctx.actionLink,
      target: "_blank"
    }, _toDisplayString(_ctx.actionLink), 9, _hoisted_1)
  ]))
}